import { useEffect } from "react";

export const useScrollClip = (clip: boolean) => {
  useEffect(() => {
    if (clip) {
      const html = document.querySelector('html');
      if (html) {
        const scrollBarWidth = window.innerWidth - html.clientWidth;
        if (scrollBarWidth) {
          const overflowY = html.style.overflowY;
          html.style.overflowY = 'clip';
          return () => {
            html.style.overflowY = overflowY;
          }
        }
      }
    }
  }, [clip]);
}
